import { updateServiceConfig } from 'owa-service/lib/config';

export function setDisableAllRequests(value: boolean) {
    updateServiceConfig({ disableAllRequests: value });
}
